(() => {
  const isMega = (t) => /MegaMenuList|--menu-columns/i.test(t || "");
  const move = () => {
    document.querySelectorAll("nav style, header style, .header-menu style, .menu-list style").forEach((node) => {
      if (!isMega(node.textContent)) return;
      document.head.appendChild(node);
    });
  };
  move();
  new MutationObserver(move).observe(document.documentElement, { childList: true, subtree: true });
})();